import React from 'react';
import { Box, Button, SxProps, Theme } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';

interface DeleteControlsProps {
  deleteButtonText: string;
  onCancelDelete: () => void;
  onConfirmDelete: () => void;
  isConfirming: boolean;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

/**
 * Controls shown when in delete mode for a resource
 */
const DeleteControls: React.FC<DeleteControlsProps> = ({
  deleteButtonText,
  onCancelDelete,
  onConfirmDelete,
  isConfirming,
  disabled,
  sx: customSx = {},
}) => {
  if (disabled) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        alignItems: 'center',
        ml: 2,
        ...customSx,
      }}
    >
      <Button
        color="secondary"
        size="small"
        onClick={onCancelDelete}
        startIcon={<CloseIcon />}
        sx={{
          textTransform: 'none',
          borderColor: 'info.main',
          color: 'secondary.dark',
          '&:hover': {
            borderColor: 'secondary.dark',
          },
          whiteSpace: 'nowrap',
        }}
      >
        Cancel Delete
      </Button>

      <Button
        color="error"
        size="small"
        onClick={onConfirmDelete}
        startIcon={<DeleteIcon />}
        sx={{
          textTransform: 'none',
          borderColor: 'error.main',
          color: 'error.main',
          '&:hover': {
            borderColor: 'error.dark',
          },
          whiteSpace: 'nowrap',
        }}
      >
        {isConfirming ? 'Confirm Delete' : deleteButtonText}
      </Button>
    </Box>
  );
};

export default DeleteControls;
